exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details-nav/group-details-nav.component.css
// module id = ../../../../../src/app/components/group-details-nav/group-details-nav.component.css
// module chunks = 0